<template>
  <div>
    <div class="choose">
      <!-- 学年 -->
      <van-field label="学年"
                 @click="isYearShow=true"
                 placeholder="请选择学年"
                 readonly
                 v-model='selectYear' />
      <!-- 学期 -->
      <van-field label="学期"
                 @click="isSessionShow=true"
                 placeholder="请选择学期"
                 readonly
                 v-model='selectSession' />
      <!-- 任课教程 -->
      <van-field label="任课教程"
                 @click="isCourseShow=true"
                 placeholder="请选择任教课程"
                 readonly
                 v-model='selectCourse' />
      <van-action-sheet v-model="isYearShow"
                        :actions="yearData"
                        @select="yearSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
      <van-action-sheet v-model="isSessionShow"
                        :actions="sessionData"
                        @select="sessionSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
      <van-action-sheet v-model="isCourseShow"
                        :actions="courseData"
                        @select="courseSelectFun"
                        cancel-text="取消"
                        close-on-click-action />
      <van-button type="info"
                  size="large"
                  @click="search"
                  style="margin-top:15px;">搜索</van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MyStudents',
  components: {},
  data () {
    return {
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: [],
      //任教课程
      isCourseShow: false,
      selectCourse: "",
      selectCourseId: 0,
      courseData: [],
      courseInfoData: [],//所有课程详细列表（包含所有的信息）
    }
  },
  created () {
    this.getYear();
  },
  mounted () {
  },
  methods: {
    //获取学年
    async getYear () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/YearList`);
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectYearId = item.ID;
              this.selectYear = item.Name;
              this.getSession(item.ID);
            }
            this.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        } else {
          this.$toast.fail('未查询到学年');
        }
      }
    },
    //获取学期
    async getSession (id) {
      this.xy.loading();
      this.selectSession = "";
      this.selectSessionId = 0;
      this.sessionData = [];
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, {
        yearID: id
      });
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectSessionId = item.AcademicSessionID;
              this.selectSession = item.AcademicSessionName;
              this.getCourse(item.AcademicSessionID);
            }
            this.sessionData.push({
              id: item.AcademicSessionID,
              name: item.AcademicSessionName
            });
          });
        } else {
          this.$toast.fail('未查询到学期');
        }
      }
    },
    //获取任教课程
    async getCourse (id) {
      this.xy.loading();
      this.selectCourse = "";
      this.selectCourseId = 0;
      this.courseData = [];
      this.courseInfoData = [];
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/MyStudents/GetAllCurricula`, {
        sessionID: id,
      });
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          this.courseInfoData = res.data;
          res.data.map(item => {
            this.courseData.push({
              id: item.CoursePlanAID,
              name: `${item.SubjectName} | ${item.CoursePlanTableFullName}`
            });
          });
        } else {
          this.$toast.fail('未查询到任教课程');
        }
      }
    },
    //选中学年
    yearSelectFun (e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //学期重置
      this.getSession(e.id);
      //任教课程重置
      this.selectCourse = "";
      this.selectCourseId = 0;
      this.courseData = [];
      this.courseInfoData = [];
    },
    // 选中学期
    sessionSelectFun (e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      //任教课程重置
      this.getCourse(e.id);
    },
    // 选中任教课程
    courseSelectFun (e) {
      this.selectCourse = e.name;
      this.selectCourseId = e.id;
    },
    // 搜索
    search () {
      if (this.selectCourseId === 0) {
        this.$toast.fail('请选择任课教程');
      } else {
        //当前选中的课程信息组合（CoursePlanAID，CollectionID，CoursePlanAIDType），用于查找学生列表
        let arr = [];
        for (let index in this.courseInfoData) {
          if (this.courseInfoData[index].CoursePlanAID === this.selectCourseId) {
            //以下三项顺序不可改变
            arr.push(this.courseInfoData[index].CollectionID);
            arr.push(this.courseInfoData[index].CoursePlanAID);
            arr.push(this.courseInfoData[index].CoursePlanAIDType);
          }
        }
        this.$router.push({
          path: '/home/MyStudentsList',
          query: {
            curSessionId: this.selectSessionId,
            curCourseInfo: arr.join(),
          }
        });
      }
    },

  }
}
</script>
<style lang="less" scoped>
</style>
